// Styles
import styled from 'styled-components/macro'

// Core
import React from 'react'

// Components, services, constants
import Icon from 'components/Icon'
import type {IconButtonVariant} from 'components/IconButton/IconButton'
import {Styled as StyledIconButton} from 'components/IconButton/IconButton'

// 3rd party
import classnames from 'classnames'
import NavLinkWithRef from 'components/NavLinkWithRef'

type Props = {
  activeClassName?: string
  className?: string
  disabled?: boolean
  exact?: boolean
  isActive?: () => boolean
  location?: {
    key?: string
    pathname?: string
    search?: string
    hash?: string
    state?: {}
  }
  icon: string
  to?: string
  href?: string
  target?: '_blank'
  variant: IconButtonVariant
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  innerRef?: React.RefObject<HTMLButtonElement>
  size: 'small' | 'medium' | 'large'
}

const LinkIconButton = ({
  activeClassName,
  className,
  icon,
  exact,
  isActive,
  location,
  variant,
  disabled,
  to,
  href,
  target,
  onClick,
  innerRef,
  size
}: Props) => {
  const linkProps = href
    ? {as: 'a', href, target}
    : {
        as: NavLinkWithRef as any,
        to,
        activeClassName: classnames('link-button-active', activeClassName),
        exact,
        location,
        isActive,
        onClick
      }
  return (
    <LinkIconButton.Styled
      ref={innerRef}
      className={classnames('icon-button', className)}
      variant={variant}
      disabled={disabled}
      onClick={onClick}
      $size={size}
      {...linkProps}
    >
      <Icon icon={icon} />
    </LinkIconButton.Styled>
  )
}

LinkIconButton.Styled = styled(StyledIconButton)`
  text-decoration: none;
`

LinkIconButton.defaultProps = {
  variant: 'light',
  size: 'medium'
}

export default LinkIconButton
